import type { IJobAssociatedMaintenanceType, IMaintenanceType } from '@/interfaces'
import Base from '../Base'
import { MaintenanceType } from '../maintenance-type'

class JobAssociatedMaintenanceType extends Base implements IJobAssociatedMaintenanceType {
  id: string

  typeId: string  

  type: IMaintenanceType

  workHours: number

  constructor(maintenanceType: any) {
    super(maintenanceType)
    this.id = maintenanceType.id
    this.typeId = maintenanceType.typeId
    this.type = new MaintenanceType(maintenanceType.type)
    this.workHours = maintenanceType.workHours
  }
}

export default JobAssociatedMaintenanceType
